import { DataServiceWrapper } from '@redstone-finance/evm-connector'
import { multicall } from '@wagmi/core'
import { RedstoneChainLinkPriceOracleAbi } from 'abis/RedstoneChainLinkPriceOracle'
import { wagmiConfig } from 'services/wallet/chains'
import { Address, Hex, hexToString } from 'viem'

export async function getRedstonePayload(opts: {
  uniqueSignersCount: number
  dataFeeds: string[]
  dataServiceId: string
}): Promise<Hex> {
  if (opts.dataFeeds.length === 0) return '0x'
  const signedRedstonePayload = new DataServiceWrapper(opts)

  const shouldBeMultipleOf32 = true
  const payloadWithoutZeroExPrefix =
    await signedRedstonePayload.prepareRedstonePayload(shouldBeMultipleOf32)

  return `0x${payloadWithoutZeroExPrefix}`
}

getRedstonePayload.fromContract = async (oracle: Address): Promise<Hex> => {
  const contract = {
    abi: RedstoneChainLinkPriceOracleAbi,
    address: oracle,
  }
  try {
    const [dataServiceId, uniqueSignersCount, dataFeedsBytes] = await multicall(wagmiConfig, {
      contracts: [
        {
          ...contract,
          functionName: 'getDataServiceId',
        },
        {
          ...contract,
          functionName: 'getUniqueSignersThreshold',
        },
        {
          ...contract,
          functionName: 'feedIds',
        },
      ],
      allowFailure: false,
    })

    const dataFeeds = dataFeedsBytes.map((dataFeedBytes) =>
      hexToString(dataFeedBytes, { size: 32 }),
    )

    if (dataFeeds.length === 0 || (dataFeeds.length === 1 && dataFeeds[0] === '')) return '0x'

    return getRedstonePayload({
      uniqueSignersCount,
      dataFeeds,
      dataServiceId,
    })
  } catch (e) {
    return '0x'
  }
}
